<router-outlet></router-outlet>
<coop-footer [navItems]="navItems"></coop-footer>
<coop-connect></coop-connect>
